import PropTypes from 'prop-types';
import React from 'react';

const MemberRole = ({ role, userType }) => {
  const getBadgeClass = (word) => {
    if (word === 'manager') {
      return 'badge bg-full-manager capitalize';
    }

    if (word === 'supervisor') {
      return 'badge bg-info capitalize';
    }

    if (word === 'creator' || word === 'account owner' || word === 'admin') {
      return 'badge bg-primary capitalize';
    }

    return 'badge bg-secondary-soft capitalize';
  };
  return (
    <>
      <span className={getBadgeClass(userType)}>{userType}</span>
      {role && role !== '' && (
        <span className="badge bg-primary-soft capitalize ms-2">
          Custom Role: {role}
        </span>
      )}
    </>
  );
};

MemberRole.propTypes = {
  role: PropTypes.string,
  userType: PropTypes.string,
};

export default MemberRole;
